import axios from 'axios';
import { useState, useContext, useEffect} from 'react'
import { Context } from '../../context/Context';
import MainNav from '../Navbar/MainNav';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../../assets/css/UserSettings.css'
import Footer from '../footer/Footer';
import Avatar from '../../assets/images/avatar.jpg'

const UserSettings = () => {
    const PF = "https://heroblog-api.onrender.com/images/";
    const {user, dispatch} = useContext(Context);
    const [file, setFile] = useState<File | null>(null);
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [profilePic, setProfilePic] = useState("");
    const [password, setPassword] = useState("");
    const [bio, setBio] = useState("");
    const [updateSuccess, setUpdateSuccess] = useState(false);



    const handleSubmit = async (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();

        const updatedUser = {
            userId: user._id,
            username,
            email,
            profilePic,
            password,
            bio,
        }
        if(file) {
            const data = new FormData();
            const filename = Date.now() + file.name;
            data.append('name', filename);
            data.append('file', file);
            updatedUser.profilePic = filename;
            try {
                await axios.post('/upload', data)
            }catch(err) {}
        }
        try {
            await axios.put('/users/'+user._id, updatedUser);
            setUpdateSuccess(true);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
        }catch (err) {

        }
    }

  return (
    <div className='controll__footer'>
    <MainNav/>
      {updateSuccess && <div className='success'>Update profile successfully</div>}
      <Container className='user__top'>
        <Row>
          <Col>
            <h3>Edit Profile</h3>
          </Col>
        </Row>
      </Container>
      <Container className='user__info__wrap'>
        <Row>
          <Col>
            <form onSubmit={handleSubmit}>
                {user?.profilePic !== "" ?
                <img src={file ? URL.createObjectURL(file) : PF+user?.profilePic} width="125" height="125" alt=""/> :
                <img src={Avatar} width="25" height="25" alt="" /> }
                <div className="input__wrap">
                  <input type="file" 
                  onChange={(e) => setFile(e.target.files![0])}
                  />
                </div>
                <div className="input__wrap">
                  <input type="text" 
                  placeholder={user?.username}
                  onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div className="input__wrap">
                  <input type="email" 
                  placeholder={user?.email}
                  onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="input__wrap">
                  <input type="password" 
                  placeholder='add a new password'
                  onChange={e => setPassword(e.target.value)}
                  />
                </div>
                <div className="input__wrap">
                  <textarea 
                  placeholder={user?.bio}
                  onChange={(e) => setBio(e.target.value)}
                  rows={5}
                  >
                  </textarea>
                </div>
                <button type='submit'>Update</button>
              </form>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  )
}

export default UserSettings
